import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Typography from '@ui/Typography';
import { getTimeUnitFromEpochMs } from '../../../util/timestampFormatting';
import { TimeUnit } from '../../../util/timeUnit';

interface CommentTimestampProps {
  createdAt: string;
}

const CommentTimestamp = ({ createdAt }: CommentTimestampProps) => {
  const { classes } = useStyles();
  const timeUnit = getTimeUnitFromEpochMs(createdAt);

  if (timeUnit.type === TimeUnit.Error) return null;

  if (timeUnit.type === TimeUnit.Now)
    return (
      <Typography variant="pSm" color="secondary" className={classes.timestamp}>
        {TimeUnit.Now}
      </Typography>
    );

  return (
    <Typography variant="pSm" color="secondary" className={classes.timestamp}>
      {`${timeUnit.value}${timeUnit.type}`}
    </Typography>
  );
};

const useStyles = makeStyles()(theme => ({
  timestamp: {
    whiteSpace: 'nowrap',
  },
}));

export default CommentTimestamp;
